import React from 'react';

const PurpleInfo = ({ text, children }) => {
  return (
    <div className='purple-info-container'>
      <span className='purple-info-text'>{text}</span>
      {children}
    </div>
  );
};
export default PurpleInfo;
